import React from "react";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ListUnstyled, ContainerWrapper } from "../Utils";
import { 
  faFacebookSquare, 
  faLinkedin, 
  faTwitterSquare, 
  faCreativeCommons, 
  faCreativeCommonsBy 
} from "@fortawesome/free-brands-svg-icons";
import { JoinGERS } from "../CallAction";
import "./index.css";

class Footer extends React.Component {
  componentDidMount() {
    console.log(this.props);
  }
  isPage_() {
    const { match } = this.props;
    if (match) {
      console.log(match);
      switch(window.location.pathname) {
        case "/joinus":
        case "/contact-us":
        case "/contribute":
        return '';
        default:
        return <JoinGERS />
      }     
    }
    return <JoinGERS />
  }
  render() {
    return (
      <React.Fragment>
        { 
          this.isPage_()
        }
        <footer className="App-footer mt-0 pt-5 pb-3">
          <ContainerWrapper className="footer-container">
            <FooterLinks />
            <CopyrightAndSocials /> 
          </ContainerWrapper>
        </footer>
      </React.Fragment>
    );
  }  
}

const CopyrightAndSocials = () => (
  <div className="footer-flex__socials d-flex w-100 py-3">
  <div className="footer-socials--left w-100"><small>© 2018 Global Cybersecurity Resource. Distributed under <FontAwesomeIcon icon={faCreativeCommons} size="lg"/> <FontAwesomeIcon icon={faCreativeCommonsBy} size="lg"/></small></div>
  <div className="footer-socials--right w-100">
    <ListUnstyled className="my-0 w-100">
      <li><a href="https://www.facebook.com/GERS-2098992853695953/" target="_blank" rel="noopener noreferrer" alt="GERS facebook"><FontAwesomeIcon icon={faFacebookSquare} size="lg" /></a></li>
      <li><a href="https://www.linkedin.com/in/gers" target="_blank" rel="noopener noreferrer" alt="GERS linkedin"><FontAwesomeIcon icon={faLinkedin} size="lg" /></a></li>
      <li><a href="https://twitter.com/official_gers" target="_blank" rel="noopener noreferrer" alt="GERS twitter"><FontAwesomeIcon icon={faTwitterSquare} size="lg" /></a></li>
    </ListUnstyled>
  </div>
</div>
  );


const FooterLinks = () => (
  <div className="d-flex footer-flex__links w-100 mb-4">
    <div className="footer__links--left py3">
      <ListUnstyled>
        <li><Link to="/license"><span data-item="license" className="section__footer--small">License</span></Link></li>
        <li><Link to="/contribute"><span className="section__footer--small">Contribute</span></Link></li>
        <li><Link to="/acknowledgement"><span className="section__footer--small">Acknowledgement</span></Link></li>
      </ListUnstyled>
    </div>
    <div className="footer__links--left py3">
      <ListUnstyled>
      <li><Link to="/in-the-media"><span className="section__footer--small">In the media</span></Link></li>
        <li><Link to="/experiences"><span className="section__footer--small">Experiences</span></Link></li>
        <li><Link to="/assess"><span className="section__footer--small">Assess</span></Link></li>
        <li><Link to="/machine-learning"><span className="section__footer--small">Machine learning</span></Link></li>
        <li><Link to="/investment"><span className="section__footer--small">Investment</span></Link></li>
      </ListUnstyled>
    </div>
    <div className="footer__links--left py3">
      <ListUnstyled>
        <li><Link to="/contact-us"><span className="section__footer--small">Contact us</span></Link></li>
        <li><Link to="/our-people"><span className="section__footer--small">Our people</span></Link></li>
        <li><Link to="/about-us"><span className="section__footer--small">About us</span></Link></li>
        <li><Link to="/reviewers"><span className="section__footer--small">Reviewers</span></Link></li>
        <li><Link to="/faq"><span className="section__footer--small">FAQ</span></Link></li>
      </ListUnstyled>
    </div>
  </div>
);
const ShowFooter = withRouter(Footer);
export default ShowFooter



// WEBPACK FOOTER //
// ./src/Components/Footer/index.js